module.exports = __webpack_public_path__ + "img/hdgz@2x.629a5825.png";